import { useParams } from 'react-router-dom'

import { Box, Button } from '@factorialco/deprecated-design-system'
import { TrainingMembershipsDataTableQuery } from 'generated/resources/datatable.graphql'

import { useDataTable } from 'modules/core/components/DataTable'
import PopoverMenu from 'modules/core/components/PopoverMenu'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

interface Props {
  emptyClasses: boolean
}
export const AddParticipantsRow = ({ emptyClasses }: Props) => {
  const data = useDataTable<TrainingMembershipsDataTableQuery>()
  const { navigation } = useNavigation()
  const { id } = useParams()

  return (
    <Box gap="s8" flexDirection="row">
      <Button.Router
        type="secondary"
        iconName="add"
        to={{
          pathname:
            navigation.trainings.list.details_revamp.view.participants.addParticipants.fullPath({
              id: Number(id),
            }),
        }}
      >
        {i18n.t(
          'trainings.trainings_revamp.training_detail.employees_table.dropdown.add_participants'
        )}
      </Button.Router>
      <PopoverMenu type="list">
        <PopoverMenu.Trigger disabled={data.selectedRows.size === 0}>
          <Button.Decorative
            iconName="ellipsis"
            type="secondary"
            disabled={data.selectedRows.size === 0}
          />
        </PopoverMenu.Trigger>
        <PopoverMenu.Content side="bottom" align="center">
          <PopoverMenu.RouterOption
            title={i18n.t(
              'trainings.trainings_revamp.training_detail.employees_table.dropdown.assign_participants'
            )}
            to={
              emptyClasses
                ? navigation.trainings.list.details_revamp.view.trainingClasses.tab.newClass.fullPath(
                    {
                      id: Number(id),
                    }
                  )
                : navigation.trainings.list.details_revamp.view.participants.assignParticipants.fullPath(
                    { id: Number(id) }
                  )
            }
            icon="user"
          />
          <PopoverMenu.RouterOption
            title={i18n.t(
              'trainings.trainings_revamp.training_detail.employees_table.dropdown.delete_participants'
            )}
            to={navigation.trainings.list.details_revamp.view.participants.deleteParticipants.fullPath(
              { id: Number(id) }
            )}
            icon="delete"
          />
        </PopoverMenu.Content>
      </PopoverMenu>
    </Box>
  )
}
